var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 10.4998H31.3333C31.3333 4.79067 26.7091 0.166504 21 0.166504C15.2908 0.166504 10.6666 4.79067 10.6666 10.4998H5.49998C2.65831 10.4998 0.333313 12.8248 0.333313 15.6665V46.6665C0.333313 49.5082 2.65831 51.8332 5.49998 51.8332H36.5C39.3416 51.8332 41.6666 49.5082 41.6666 46.6665V15.6665C41.6666 12.8248 39.3416 10.4998 36.5 10.4998ZM21 5.33317C23.8416 5.33317 26.1666 7.65817 26.1666 10.4998H15.8333C15.8333 7.65817 18.1583 5.33317 21 5.33317ZM36.5 46.6665H5.49998V15.6665H10.6666V20.8332C10.6666 22.254 11.8291 23.4165 13.25 23.4165C14.6708 23.4165 15.8333 22.254 15.8333 20.8332V15.6665H26.1666V20.8332C26.1666 22.254 27.3291 23.4165 28.75 23.4165C30.1708 23.4165 31.3333 22.254 31.3333 20.8332V15.6665H36.5V46.6665Z",
    fill: "#F26654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.e406fe938ae0949ef050d66b438fb6d0.svg";
export { ForwardRef as ReactComponent };